import SimonDataSignUp from '../footer/simondata-signup';
import YotpoSMS from '../footer/yotpo-sms';

class DomaineInputSubmit extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.error = this.querySelector('[data-error]');
    this.errorText = this.error ? this.error.textContent : '';
    this.submit = this.querySelector('button[type="submit"]');
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('[data-success]');
    this.inputWrapper = this.querySelector('domaine-input');

    this.formAction = this.form.action;
    this.analyticsEvent = this.getAttribute('analytics-event');
    this.consentRequired = this.getAttribute('consent-required');
  }

  connectedCallback() {
    if (this.hasAttribute('data-newsletter-form')) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        SimonDataSignUp(this.analyticsEvent, this.consentRequired);
      });
    } else if (this.hasAttribute('data-sms-form')) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        YotpoSMS();
      });
    } else {
      this.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.hasAttribute('data-newsletter-form')) {
      this.form.removeEventListener('submit', (e) => {
        e.preventDefault();
        SimonDataSignUp(this.analyticsEvent, this.consentRequired);
      });
    } else if (this.hasAttribute('data-sms-form')) {
      this.form.removeEventListener('submit', (e) => {
        e.preventDefault();
        YotpoSMS();
      });
    } else {
      this.removeEventListener('submit', this.handleSubmit);
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    // TODO: Might need to make this more flexible for multiple scenarios
    const formData = new FormData(this.form);
    const data = Object.fromEntries(formData);

    try {
      this.submit.disabled = true;
      const res = await fetch(this.formAction, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!res.ok) throw new Error('Network response was not ok');

      this.setAttribute('success', '');
      this.input.value = '';

      if (this.analyticsEvent) {
        Shopify.analytics.publish(this.analyticsEvent, data);
      }

      setTimeout(() => {
        this.removeAttribute('success');
      }, 3000);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error submitting form', error);
      this.inputWrapper.setAttribute('error', '');
    }
  }
}

customElements.define('domaine-input-submit', DomaineInputSubmit);
